import { Footer, Loader, PageLayout } from '@bharatpe/bharat-ui';
import React, { useEffect, useState } from 'react';
import ComplaintBox from './ComplaintBox';
import TicketDetails from './TicketDetails';
import UpiPoweredBy from 'components/atoms/UpiPoweredBy';
import history from 'utils/History';
import { GetUdirComplaint } from 'Services';
import AppHeader from 'components/atoms/AppHeader';
import Toasty from 'components/atoms/Toasty';
import { sendEvent } from 'utils/Sentry';
import { logAnalyticsEvent } from 'utils/AnalyticsEvent';
import { useLanguageConfig } from 'Slices/LanguageConfigSlice';
import { closeNativeSupport } from 'utils/nativeSupport';

const UdirDetails = () => {
	const [complaintId, setComplaintId] = useState<any>(history.location.state);
	const [complaintDetails, setComplaintDetails] = useState<any>({});
	const [loading, setLoading] = useState(true);
	const { languageData } = useLanguageConfig();

	useEffect(() => {
		logAnalyticsEvent({
			trigger_point: 'Page view',
			Product: 'AutoPayUPI',
			Flow: 'UDIR',
			Screen: 'UDIR_Det',
			Module: 'Page',
			Action: 'Viewed',
			status: complaintDetails?.status,
		});
	}, []);

	const fetchComplaint = async (complaintId: any) => {
		if (complaintId) {
			try {
				const complaint = await GetUdirComplaint(complaintId);
				if (complaint) {
					setComplaintDetails(complaint);
					setLoading(false);
				}
			} catch (err: any) {
				setLoading(false);
				Toasty.error(err?.error);
				sendEvent(err);
			}
		}
	};

	useEffect(() => {
		if (complaintId) {
			setComplaintId(complaintId);
			fetchComplaint(complaintId);
		}
	}, [complaintId]);

	const backEventAction = () => {
		logAnalyticsEvent({
			trigger_point: 'Clicks on back button',
			Product: 'AutoPayUPI',
			Flow: 'UDIR',
			Screen: 'UDIR_Det',
			Element: 'back',
			Action: 'Tapped',
			source: 'appHeader',
			status: complaintDetails?.status,
		});
	};
	return loading ? (
		<Loader loading />
	) : (
		<PageLayout
			className="pb18 white-background"
			footerContent={
				<Footer
					primaryActionText={languageData.DONE}
					primaryAction={() => {
						closeNativeSupport();
					}}
				/>
			}>
			<>
				<AppHeader title={`#${complaintDetails?.complaint_ref_no}`} backEventAction={backEventAction} />
				<ComplaintBox complaintDetails={complaintDetails} />
				<TicketDetails complaintDetails={complaintDetails} />
				<div className="content-center">
					<UpiPoweredBy />
				</div>
			</>
		</PageLayout>
	);
};

export default UdirDetails;
